import {Component} from '@angular/core';
import {SignUpService} from "../../service/sign-up.service";
import {RegistrationBaseComponent} from "../registration-base-component/registration-base-component";
import {RegistrationApiService} from "../../api/registration-api.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {AppMessageService} from "../../../core/service/app-message.service";
import {Router} from "@angular/router";
import {LocationStrategy} from "@angular/common";
import {fromEvent, Subject, takeUntil} from "rxjs";


@Component({
  selector: 'registration-success',
  templateUrl: './registration-success.component.html',
  styleUrl: './registration-success.component.scss'
})
export class RegistrationSuccessComponent extends RegistrationBaseComponent {

  private unsubscriber : Subject<void> = new Subject<void>();


  constructor(protected override registrationApiService: RegistrationApiService,
              protected override signUpService: SignUpService,
              protected router: Router,
              protected override coreApiService: CoreApiService) {
    super(registrationApiService,signUpService,coreApiService);

  }

  override ngOnInit(): void {
    super.ngOnInit();

    history.pushState(null, '');
    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
      console.log(`You can't make changes or go back at this time.`);
    });

    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  override initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  override refreshComponent() {
    this.initialized = true;
  }

  handleNavigation() {
    this.router.navigate(["/ob/start"]);
  }

  override ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

}
